// 灰色梯度
export const Gray = {
  "gray-1": "#030303",
  "gray-2": "#18191B",
  "gray-3": "#212225",
  "gray-4": "#292B2F",
  "gray-5": "#343538",
  "gray-6": "#595B61",
  "gray-7": "#6C767F",
  "gray-8": "#9EAAAC",
  "gray-9": "#E0EDEF",
  "gray-10": "#1A1C1F",
  "gray-11": "#33373F",
  "gray-12": "#464D56",
  "gray-13": "#222326",
  "gray-14": "#9ba2b0",
} as const;

// 绿色
export const Green = {
  "green-1": "#078A4C",
  "green-2": "#13CB75",
  "green-3": "#4DDA98",
} as const;

// 蓝色
export const Blue = {
  "blue-1": "#2084F1",
} as const;

// 红色
export const Red = {
  "red-1": "#D94A41",
  "red-0-1": "rgb(217, 74, 65, 0.1)",
} as const;

// 橙色
export const Orange = {
  "orange-1": "#F8AE3F",
  "orange-2": "#F3512B",
  "orange-3": "#ED785C",
  "orange-4": "#AE4229",
} as const;

export default {
  ...Gray,
  ...Green,
  ...Blue,
  ...Red,
  ...Orange,
};
